export var InputType;
(function (InputType) {
    InputType["text"] = "text";
    InputType["password"] = "password";
    InputType["number"] = "number";
    InputType["textArea"] = "textArea";
})(InputType || (InputType = {}));
export var Border;
(function (Border) {
    Border["none"] = "none";
    Border["outline"] = "outline";
    Border["bottom"] = "bottom";
})(Border || (Border = {}));
//# sourceMappingURL=index.types.js.map